import React from 'react'
import { StyleSheet, View as NativeView, ViewStyle } from 'react-native'
// import styles from './index.scss'

interface Props {
    style?: ViewStyle|Array<ViewStyle>;
}

const View: React.FC<Props> = (props) => {

    const {
        style
    } = props;

    return (
        <NativeView {...props} style={[styles.view, style]}>
            {props.children}
        </NativeView>
    );

};

const styles = StyleSheet.create({
    view: {}
});

export {
    View
}